import React, { useContext, useState, useEffect } from "react";
import MovimientosContext from "../../context/movimientos/movimientosContext";

function ModalConfirmacionAplicado() {
  const movimientosContext = useContext(MovimientosContext);
  const {
    aplicarMovimiento,
    aplicarMultiplesMovimientos,
    setModalConfirmacionAplicado,
    loadingAplicado,
    arrCabezasAplicados,
    setArrCabezas,
    setArrCabezasAplicados,
    setDatosFormularioAlta,
  } = movimientosContext;

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto py-10">
      <div className="flex items-end justify-center min-h-screen pt-4 px-6 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div
          className="inline-block align-bottom bg-gray-200 text-left overflow-hidden shadow-xl lg:align-middle transform transition-all w-full lg:w-2/5"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div className="bg-gray-200 border-b-2 border-gray-500 px-4 my-2 pb-4 sm:p-6 sm:pb-4">
            <div className="flex justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-12 w-12 mb-1 text-blue-800"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div className="">
              <h2 className="font-bold  font-sans text-3xl text-center">
                Atención
              </h2>
              <p className="text-lg text-center text-gray-600">
                {Object.keys(arrCabezasAplicados).length > 0
                  ? "Estás a punto de aplicar estos movimientos"
                  : "Estás a punto de aplicar un movimiento"}
              </p>
              <br></br>
              <p className="text-lg text-center text-gray-600">
                ¿Está seguro/a de querer continuar?
              </p>
            </div>
          </div>
          <div className="bg-gray-200 flex justify-between p-2 pb-4 ml-4 mr-4">
            <button
              className={
                loadingAplicado
                  ? "bg-green-400 p-2 px-12 text-white"
                  : "bg-green-400 p-2 px-5 text-white"
              }
              onClick={
                Object.keys(arrCabezasAplicados).length > 0
                  ? aplicarMultiplesMovimientos
                  : aplicarMovimiento
              }
              disabled={loadingAplicado}
            >
              {loadingAplicado ? (
                <div className="flex flex-row">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="text-white animate-spin h-5 w-5"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
              ) : (
                "ACEPTAR"
              )}
            </button>
            <button
              className="bg-red-400 p-2 px-5 text-white"
              onClick={() => {
                {
                  if (Object.keys(arrCabezasAplicados).length > 0) {
                    setDatosFormularioAlta({});
                    setArrCabezas([]);
                    setArrCabezasAplicados({});
                    setModalConfirmacionAplicado(false);
                  } else {
                    setModalConfirmacionAplicado(false);
                  }
                }
              }}
            >
              CANCELAR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalConfirmacionAplicado;
